export default "__VITE_ASSET__CutaucXf__"